/**
 * Enum representing the different types of blocks available in the Block Editor
 *
 * @export
 * @enum {string}
 */
var BlockEditorDefaultBlocks;
(function (BlockEditorDefaultBlocks) {
  /** Represents a paragraph block */
  BlockEditorDefaultBlocks["PARAGRAPH"] = "paragraph";
  /** Represents a heading block */
  BlockEditorDefaultBlocks["HEADING"] = "heading";
  /** Represents a text block */
  BlockEditorDefaultBlocks["TEXT"] = "text";
  /** Represents a bullet/unordered list block */
  BlockEditorDefaultBlocks["BULLET_LIST"] = "bulletList";
  /** Represents an ordered/numbered list block */
  BlockEditorDefaultBlocks["ORDERED_LIST"] = "orderedList";
  /** Represents a list item within a list block */
  BlockEditorDefaultBlocks["LIST_ITEM"] = "listItem";
  /** Represents a blockquote block */
  BlockEditorDefaultBlocks["BLOCK_QUOTE"] = "blockquote";
  /** Represents a code block */
  BlockEditorDefaultBlocks["CODE_BLOCK"] = "codeBlock";
  /** Represents a hard break (line break) */
  BlockEditorDefaultBlocks["HARDBREAK"] = "hardBreak";
  /** Represents a horizontal rule/divider */
  BlockEditorDefaultBlocks["HORIZONTAL_RULE"] = "horizontalRule";
  /** Represents a DotCMS image block */
  BlockEditorDefaultBlocks["DOT_IMAGE"] = "dotImage";
  /** Represents a DotCMS video block */
  BlockEditorDefaultBlocks["DOT_VIDEO"] = "dotVideo";
  /** Represents a table block */
  BlockEditorDefaultBlocks["TABLE"] = "table";
  /** Represents a DotCMS content block */
  BlockEditorDefaultBlocks["DOT_CONTENT"] = "dotContent";
})(BlockEditorDefaultBlocks || (BlockEditorDefaultBlocks = {}));

/**
 * Actions received from the dotcms editor
 *
 * @export
 * @enum {number}
 */
var __DOTCMS_UVE_EVENT__;
(function (__DOTCMS_UVE_EVENT__) {
  /**
   * Request to page to reload
   */
  __DOTCMS_UVE_EVENT__["UVE_RELOAD_PAGE"] = "uve-reload-page";
  /**
   * Request the bounds for the elements
   */
  __DOTCMS_UVE_EVENT__["UVE_REQUEST_BOUNDS"] = "uve-request-bounds";
  /**
   * Received pong from the editor
   */
  __DOTCMS_UVE_EVENT__["UVE_EDITOR_PONG"] = "uve-editor-pong";
  /**
   * Received scroll event trigger from the editor
   */
  __DOTCMS_UVE_EVENT__["UVE_SCROLL_INSIDE_IFRAME"] = "uve-scroll-inside-iframe";
  /**
   * TODO:
   * Set the page data - This is used to catch the "changes" event.
   * We must to re-check the name late.
   */
  __DOTCMS_UVE_EVENT__["UVE_SET_PAGE_DATA"] = "uve-set-page-data";
  /**
   * Copy contentlet inline editing success
   */
  __DOTCMS_UVE_EVENT__["UVE_COPY_CONTENTLET_INLINE_EDITING_SUCCESS"] = "uve-copy-contentlet-inline-editing-success";
})(__DOTCMS_UVE_EVENT__ || (__DOTCMS_UVE_EVENT__ = {}));

export { BlockEditorDefaultBlocks, __DOTCMS_UVE_EVENT__ };
